// eslint-disable-next-line
export const THEME_LOCAL_STORAGE_KEY = 'theme';

export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';
